import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../../services/admin.service';
import { ManufacturerWizard } from '../../domain/eurocode';

@Component({
  selector: 'app-admin-manufacturers-form',
  templateUrl: './admin-manufacturers-form.component.html',
  styleUrls: ['./admin-manufacturers-form.component.scss']
})
export class AdminManufacturersFormComponent implements OnInit {
  manufacturerForm: FormGroup;
  isEditMode: boolean = false;
  manufacturerId: number;

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.manufacturerForm = this.fb.group({
      ManId: [{ value: '', disabled: true }, Validators.required],
      ManCode: ['', Validators.required],
      Manindex: ['', Validators.required],
      Man_En: ['', Validators.required],
      Man_Fr: ['', Validators.required],
      Man_Nl: ['', Validators.required],
      Man_De: ['', Validators.required],
      Man_It: ['', Validators.required],
      Man_Es: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.isEditMode = true;
        this.manufacturerId = params['id'];
        this.adminService.getManufacturerById(this.manufacturerId).subscribe(manufacturer => {
          this.manufacturerForm.patchValue(manufacturer);
        });
      }
    });
  }

  onSubmit(): void {
    if (this.manufacturerForm.valid) {
      const manufacturer: ManufacturerWizard = this.manufacturerForm.getRawValue();
      if (this.isEditMode) {
        this.adminService.updateManufacturer(this.manufacturerId, manufacturer).subscribe(() => {
          this.router.navigate(['/admin-manufacturers']);
        });
      } else {

     manufacturer.ManId = 0;

        this.adminService.createManufacturer(manufacturer).subscribe(() => {
          this.router.navigate(['/admin-manufacturers']);
        });
      }
    }
  }
}
